import { useEffect } from 'react';

export const useInteractiveDate = (ref: React.RefObject<HTMLInputElement>) => {
	useEffect(() => {
		if (!ref.current) {
			return;
		}

		const clickHandler = () => {
			ref.current?.showPicker();
		};

		ref.current.addEventListener('click', clickHandler);

		return () => {
			ref.current?.removeEventListener('click', clickHandler);
		};
	}, [ref]);
};
